import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';

// run once on load, and again on resize
function setViewportHeightVar() {
  document.documentElement.style.setProperty(
    '--vh',
    `${window.innerHeight * 0.01}px`
  );
}
setViewportHeightVar();
window.addEventListener('resize', setViewportHeightVar);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Clean up any service worker left over from a previous version of this app.
// This app does not use offline/PWA functionality, and a stale SW can serve
// outdated JS bundles indefinitely across deploys.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister();
    });
  });

  // Also clear any Cache Storage entries the SW may have created
  if (window.caches) {
    caches.keys().then((names) => {
      names.forEach((name) => caches.delete(name));
    });
  }
}